<template>
  <span class="text-red-500"> * </span>
</template>

<script>
export default {
  name: 'obligatory-icon',
}
</script>
